import CityPageTemplate from "../city-template/CityPageTemplate";
import { camdenConfig } from "./data";

export default function CamdenPage() {
  return <CityPageTemplate config={camdenConfig} />;
}